export const svgToString = (svg: SVGElement): string => new XMLSerializer().serializeToString(svg);

export default { svgToString };
